import { faPowerOff, faUser } from "@fortawesome/free-solid-svg-icons";
import React, { useContext } from "react";
import { UserContext } from "../../../common/user/UserContext";
import LogoutIcon from "./LogoutIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ThemeContext } from "../../../common/theme/ThemeContext";

function UserInfo() {
  const user = useContext(UserContext);
  const theme = useContext(ThemeContext);

  return (
    <div className="navbar-item">
      <button
        className={`button has-background-${theme.navColor} has-text-${theme.navText} is-${theme.navText}`}
      >
        <span className="icon">
          <FontAwesomeIcon color="#80a9e1" icon={faUser} />
        </span>
        <span className="is-uppercase">
          {user.firstName} {user.lastName}
        </span>
        <LogoutIcon
          className={`icon has-text-${theme.navColor}-${theme.navText} ml-4`}
          icon={faPowerOff}
          size={1}
        />
      </button>
    </div>
  );
}

export default UserInfo;
